import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

const allMenuStore = new Vuex.Store({
  state: {
    allMenuList: {},
  },
  mutations: {
    updateAllMenuList(state, allMenuList) {
      state.allMenuList = allMenuList;
    },
  },
  getters: {
    findPaperSizeJName: (state) => (name) => {
      if (!state.allMenuList.paper_sizes) {
        return "";
      }
      for (let i = 0; i < state.allMenuList.paper_sizes.options.length; i++) {
        if (state.allMenuList.paper_sizes.options[i].name == name) {
          return state.allMenuList.paper_sizes.options[i].name_j;
        }
      }
      return "";
    },
    findMethodsJName: (state) => (name) => {
      for (let i = 0; i < state.allMenuList.methods?.options.length; i++) {
        if (state.allMenuList.methods.options[i].name === name) {
          return state.allMenuList.methods.options[i].name_j;
        }
      }
      return "";
    },
    findPostingStatusJName: (state) => (intNumber) => {
      if (intNumber == 0) {
        return "原稿アップロード前";
      } else if (intNumber == 1) {
        return "依頼内容確認・原稿審査中";
      } else if (intNumber == 2) {
        return "原稿審査完了・トラッキング番号の入力";
      } else if (intNumber == 3) {
        return "配布依頼中";
      } else if (intNumber == 4) {
        return "配布報告完了待ち";
      } else if (intNumber == 5) {
        return "配布報告完了済み";
      } else if (intNumber == 6) {
        return "原稿審査承認 NG";
      } else if (intNumber == 7) {
        return "キャンセル";
      } else {
        return "";
      }
    },
    findPrintStatusJName: (state) => (intNumber) => {
      if (intNumber == 0) {
        return "印刷データ承認前";
      } else if (intNumber == 1) {
        return "印刷データ確認中";
      } else if (intNumber == 2) {
        return "印刷データ承認済";
      } else if (intNumber == 3) {
        return "印刷中";
      } else if (intNumber == 4) {
        return "発送済";
      } else if (intNumber == 5) {
        return "到着済";
      } else {
        return "";
      }
    },
    findOrikomiStatusJName: () => (intNumber) => {
      if (intNumber == 0) {
        return "原稿審査承認前";
      } else if (intNumber == 1) {
        return "原稿審査確認中";
      } else if (intNumber == 2) {
        return "原稿審査承認済";
      } else if (intNumber == 3) {
        return "折込依頼中";
      } else if (intNumber == 4) {
        return "折込完了報告済";
      } else if (intNumber == 5) {
        return "原稿審査承認NG";
      } else if (intNumber == 6) {
        return "注文キャンセル";
      } else {
        return "";
      }
    },
    findAreaLevelJName: (state) => (areaLevel) => {
      if (areaLevel == "town") {
        return "町丁目";
      } else if (areaLevel == "municipality") {
        return "市区町村";
      }
    },
  },

  plugins: [createPersistedState()],
});

export { allMenuStore };
